<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const props = defineProps({
  etapes: Array,
});

const nomEtapes = computed(() => props.etapes.map((e) => e.nom));

const indexCourant = computed(() => {
  return nomEtapes.value.findIndex((nom) => nom === route.meta.etape);
});

function getClassIndexStepper(index) {
  if (indexCourant.value === index) return "lg:h-7 lg:w-7 stepper-active";
  if (indexCourant.value > index) return "lg:h-5 lg:w-5 stepper-active";
  if (indexCourant.value < index) return "lg:h-5 lg:w-5";
}

function getClassLibelleStepper(index) {
  if (indexCourant.value === index)
    return "text-base font-bold libelle-active";
  if (indexCourant.value > index)
    return "text-xs font-semibold libelle-active";
  if (indexCourant.value < index) return "text-xs font-semibold";
}

function getClassStepper(index) {
  if (index === 0 && indexCourant.value === 0)
    return "h-5 lg:h-3/6 rounded-l-full rounded-r-full lg:rounded-t-full lg:rounded-b-full stepper-active";
  if (indexCourant.value > index && index === 0)
    return "h-full rounded-l-full lg:rounded-t-full lg:rounded-b-none stepper-active border-r-2 lg:border-r-0 lg:border-b-2 border-gray-200";
  if (indexCourant.value > index)
    return "h-full stepper-active border-r-2 lg:border-r-0 lg:border-b-2 border-gray-200";
  if (indexCourant.value < index) return "";
}
function getIsBlocFinEtapeActive(index) {
  if (index === 0 || indexCourant.value === 0) return "hidden";
  if (indexCourant.value === index) return "h-5 lg:h-3/6 stepper-active";
}
</script>

<template>
    <div id="stepper" class="containerStepper">
        <div
            class="containerEtape w-52"
            v-for="(etape, index) in etapes"
            :key="index"
        >
            <div class="conteneur-etape-stepper">
                <div
                    class="element-barre-stepper"
                    :class="{ 'rounded-t-full': index === 0 }"
                >
                    <div
                        class="element-actif-fin-etape"
                        :class="getIsBlocFinEtapeActive(index)"
                    />
                    <div
                        class="w-full lg:w-full"
                        :class="getClassStepper(index)"
                    />
                </div>
                <div class="etapes" :class="getClassLibelleStepper(index)">
                    <div class="chiffres" :class="getClassIndexStepper(index)">
                        {{ index + 1 }}
                    </div>
                    <span class="hidden lg:inline">{{ etape.libelle }}</span>
                </div>
            </div>
        </div>

        <div class="containerEtape w-1/6 lg:w-52">
            <div class="conteneur-element-fin-etape">
                <div class="conteneur-element-fin-etape-lie-au-stepper">
                    <div
                        class="element-fin-etape-neutre"
                        :class="{ 'rounded-t-full': index === 0 }"
                    />
                    <div class="element-fin-stepper-lg" />
                    <img
                        class="pastille-utilisateur-fin-etape-mobile"
                        src="@/assets/img/utilisateur.svg"
                    />
                </div>
                <div class="conteneur-libelle-fin-etape">
                    <span
                        class="conteneur-pastille-utilisateur-libelle-fin-etape"
                    >
                        <img
                            class="h-full w-full"
                            src="@/assets/img/utilisateur.svg"
                        />
                    </span>
                    <span>Mon courtier</span>
                </div>
            </div>
        </div>
    </div>
</template>
